export const IconAge: {
  name: 'icon_age-880779d518a0'
} = {
  name: 'icon_age-880779d518a0'
}
